import AdsAPI from './ads'

export { AdsAPI }
